<span class="sr-only" [id]="fieldId">
  <ng-content></ng-content>
</span>
